(function(){
  if(window.__ceAtc)return;window.__ceAtc=1;
  var D=document,ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var live;
  function say(t){
    if(!live){live=D.createElement('div');live.className='sr-only';live.setAttribute('role','status');live.setAttribute('aria-live','polite');D.body.appendChild(live)}
    live.textContent='';setTimeout(function(){live.textContent=t},30);
  }
  function setLabel(b,t){b.textContent=t}
  function reset(b){
    b.classList.remove('is-done','is-error');b.removeAttribute('aria-busy');
    setLabel(b,b.getAttribute('data-ce-label')||'In den Warenkorb');
  }
  function add(b){
    if(b.getAttribute('aria-busy')==='true')return;
    var id=parseInt(b.getAttribute('data-variant-id'),10);if(!id)return;
    var title=(b.getAttribute('aria-label')||'').split(':')[0];
    if(!b.getAttribute('data-ce-label'))b.setAttribute('data-ce-label',b.textContent.trim());
    b.setAttribute('aria-busy','true');b.classList.remove('is-done','is-error');setLabel(b,'Wird hinzugefügt');
    var secs=[];
    D.dispatchEvent(new CustomEvent('cart:push:section.id',{bubbles:true,detail:{sections:secs}}));
    var body={items:[{id:id,quantity:1}]};if(secs.length)body.sections=secs.join(',');
    fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Fehler');return j})})
      .then(function(j){
        return fetch(ROOT+'cart.js').then(function(r){return r.json()}).then(function(cart){
          cart.sections=j.sections||{};
          D.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart:cart}}));
        });
      })
      .then(function(){
        b.removeAttribute('aria-busy');b.classList.add('is-done');setLabel(b,'Hinzugefügt');
        say((title||'Produkt')+' wurde in den Warenkorb gelegt.');
        setTimeout(function(){reset(b)},1800);
      })
      .catch(function(e){
        b.removeAttribute('aria-busy');b.classList.add('is-error');setLabel(b,'Fehler, nochmal versuchen');
        say('Das Produkt konnte nicht hinzugefügt werden. '+(e&&e.message?e.message:''));
        setTimeout(function(){reset(b)},3500);
      });
  }
  D.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('button.ce-atc[data-variant-id]');
    if(!b||b.disabled)return;
    e.preventDefault();add(b);
  });
  function esc(s){var d=D.createElement('div');d.textContent=s;return d.innerHTML.replace(/"/g,'&quot;')}
  function fill(card){
    if(card.querySelector('.ce-atc')||card.getAttribute('data-ce-fb'))return;
    var a=card.querySelector('a[data-pr-url],a[href*="/products/"]'),info=card.querySelector('.hdt-card-product__info');
    if(!a||!info)return;
    var m=(a.getAttribute('href')||'').match(/\/products\/([^/?#]+)/);if(!m)return;
    card.setAttribute('data-ce-fb','1');
    fetch(ROOT+'products/'+m[1]+'.js').then(function(r){return r.json()}).then(function(p){
      if(card.querySelector('.ce-atc'))return;
      var t=esc(p.title),h;
      if(!p.available)h='<button type="button" class="ce-atc ce-atc--soldout" data-ce-atc disabled aria-disabled="true" aria-label="'+t+': ausverkauft">Ausverkauft</button>';
      else if(p.variants.length>1)h='<a class="ce-atc ce-atc--options" data-ce-atc href="'+esc(a.getAttribute('href'))+'" aria-label="'+t+': Optionen wählen">Optionen wählen</a>';
      else h='<button type="button" class="ce-atc" data-ce-atc data-variant-id="'+p.variants[0].id+'" aria-label="'+t+': In den Warenkorb">In den Warenkorb</button>';
      var w=D.createElement('div');w.className='ce-atc-wrap';w.innerHTML=h;info.appendChild(w);
    }).catch(function(){});
  }
  function scan(){[].forEach.call(D.querySelectorAll('hdt-card-product'),fill)}
  var tm;
  function later(){clearTimeout(tm);tm=setTimeout(scan,250)}
  function init(){scan();try{new MutationObserver(later).observe(D.body,{childList:true,subtree:true})}catch(e){}}
  if(D.readyState==='loading')D.addEventListener('DOMContentLoaded',init);else init();
})();
